import styled from 'styled-components';

export const Wrapper = styled.div`
  height: fit-content;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
`;

export const ContainerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  border: 1px solid #f7f7f7;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  position: relative;
  margin-bottom: 0.5rem;

  @media (max-width: 768px) {
    min-height: 5.375rem;
  }

  &.by_industry {
    margin-bottom: 0px;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 1px;
    background-color: #1b7bdd;

    @media (min-width: 36rem) {
      width: 36rem;
    }

    @media (min-width: 48rem) {
      display: none;
    }
  }

  @media (min-width: 36rem) {
    padding: 0 5rem;
  }

  &.filter-by {
    @media (min-width: 48rem) {
      display: none;
    }
  }

  @media (min-width: 48rem) {
    align-items: stretch;
    padding: 0;
    margin-bottom: 0;
  }
`;

export const Tab = styled.div`
  display: none;

  @media (min-width: 48rem) {
    display: flex;
    width: 100%;
    outline: none;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-right: 1px solid #ebebeb;
    background-color: transparent;
    font-family: 'DINRegular';
    font-size: 12px;
    text-transform: uppercase;
    margin: 0;
    padding: 30px;
    border-bottom: 1px solid ${({ selected }) => (selected ? '#1b7bdd' : '#ebebeb')};

    &:last-child {
      border-right: none;
    }

    &:hover {
      border-bottom: 1px solid #1b7bdd;
    }
  }
`;

export const Label = styled.span`
  font-family: 'DINRegular';
  font-size: 12px;
  text-transform: uppercase;
  margin: 0 0.5rem;
`;

export const Select = styled.div`
  border: none;
  outline: none;
  height: 3.75rem;
  width: 95%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  border: ${({ toggle }) => (toggle ? '1px solid #dae0e5' : '1px solid transparent')};

  &:hover {
    border: 1px solid #ebebeb;
  }

  @media (min-width: 48rem) {
    width: 100%;
    height: auto;
    border: 1px solid #ebebeb;

    &.industry_select {
      padding: 0px 30px;
      border-left: 0px;
    }

    &:hover {
      border-bottom: 1px solid #1b7bdd;
    }
  }
`;

export const SelectWrapper = styled.div`
  padding: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  @media (min-width: 48rem) {
    padding: 1.8rem;
  }

  &.industry_select_wrapper {
    @media (min-width: 48rem) {
      padding: 0px;
    }
  }
`;

export const OptionContainer = styled.div`
  align-items: flex-start;
  background-color: #fff;
  border-radius: 0.25rem;
  border: 1px solid #b5d4f5;
  flex-flow: column nowrap;
  justify-content: flex-start;
  bottom: 0;
  left: 50%;
  max-height: 16rem;
  overflow-y: auto;
  padding: 0.6rem 0;
  position: absolute;
  transform: translate(-50%, 102%);
  width: 100%;
  z-index: 10;

  &.industry_option {
    border-radius: 0px;
    border: 1px solid #d8d8d8;
    transform: translate(-50%, 100%);

    @media (min-width: 62rem) {
      width: 100%;
    }
  }

  display: ${({ toggle }) => (toggle ? 'flex' : 'none')};

  @media (min-width: 62rem) {
    display: ${({ toggle }) => (toggle ? 'flex' : 'none')};
    width: 13.8rem;
  }
`;

export const Option = styled.span`
  width: 100%;
  font-size: 0.8rem;
  font-family: inherit;
  margin: 0.5rem 0;
  padding: 0.3rem 1.5rem;
  text-transform: capitalize;
  transition: all 700ms;

  ${({ selected }) => (selected ? 'background-color: #1b7bdd; color: #fff' : 'color: #212529')};

  &:hover {
    background-color: #f2f2f2;
    color: #1b7bdd;
    cursor: pointer;
  }
`;

export const ArrowDown = styled.div`
  display: block;
  width: 0.55rem;
  height: 0.55rem;
  border-left: 2px solid black;
  border-bottom: 2px solid black;
  transform: rotate(-45deg) translateY(-25%);
  margin: 0 0.5rem;
  padding-right: 7px;
`;
